export const settingsConstants = {
  GET_REQUEST: 'SETTINGS_GET_REQUEST',
  GET_SUCCESS: 'SETTINGS_GET_SUCCESS',
  GET_FAILURE: 'SETTINGS_GET_FAILURE',

  UPDATE_REQUEST: 'SETTINGS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'SETTINGS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'SETTINGS_UPDATE_FAILURE',
}